export default __webpack_public_path__ + "static/media/select-circle-area.8b08e909.svg";